import { Container } from "inversify";
import { TicketsModule } from "../widget/tickets/tickets.module";
import { ZoomModule } from "../widget/zoom/zoom.module";
import { StateModule } from "../widget/state/state.module";
import { BackgroundModule } from "../widget/background/background.module";
import { CalendarModule } from "../widget/calendar/calendar.module";
import { DragModule } from "../widget/drag/drag.module";
import { CategoriesModule } from "../widget/categories/categories.module";
import { HelpModule } from "../widget/help/help.module";
import { MetaModule } from "../widget/meta/meta.module";
import { NotificationModule } from "../widget/notification/notification.module";
import { PopoverModule } from "../widget/popover/popover.module";
import { PricesModule } from "../widget/prices/prices.module";
import { TicketsPopoverModule } from "../widget/ticketsPopover/ticketsPopover.module";

let containerControllers = new Container();

containerControllers.load(
  TicketsModule,
  ZoomModule,
  StateModule,
  BackgroundModule,
  DragModule,
  CalendarModule,
  CategoriesModule,
  HelpModule,
  MetaModule,
  NotificationModule,
  PopoverModule,
  PricesModule,
  TicketsPopoverModule,
);

export {
  containerControllers,
}